/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteVariantResponse } from '../../models/delete-variant-response';

export interface VariantsControllerDeleteVariant$Params {

/**
 * The id of the variant to remove.
 */
  id: string;
}

export function variantsControllerDeleteVariant(http: HttpClient, rootUrl: string, params: VariantsControllerDeleteVariant$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteVariantResponse>> {
  const rb = new RequestBuilder(rootUrl, variantsControllerDeleteVariant.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteVariantResponse>;
    })
  );
}

variantsControllerDeleteVariant.PATH = '/planning-projects/v1-preview/projects/variants/{id}';
